<template>
  <div>
    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Termos de uso" alinha-btn="center" :exibe_botao="false" :exibe_link="true">
      <template #default>
        <div class="row text-start" v-html="dados.termos_de_uso"></div>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { api } from '@/services/api';

export default {
  name: 'Termos_de_adesao',
  props: {
    termos: String
  },
  data() {
    return {
      dados: ''
    }
  },
  components: {
    Modal
  },
  methods: {
    async carrega_dados() {
      this.dados = await api.get('dados_home');
    },
  },
  mounted() {
    this.carrega_dados()
  },
}
</script>

<style scoped></style>